import React, { useState, useEffect } from "react";
import "../../styles/Header.scss";
import { Link } from "react-router-dom";
import brighterTextLogo from "../../assets/images/brighterTextLogo.svg";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`navbar-fixed-top headerStyle ${isScrolled ? 'scrolled' : ''}`}>
      <div className="logged-out">
        <div className="container-fluid new-wrapper">
          <div className="brighterIconWrapper">
            <img
              src={brighterTextLogo}
              alt="Brighter Logo"
              className="imgStyle"
            />
            <p>Provider questions? 424-316-2534</p>
          </div>
          <div>
            <ul className="list-inline pull-right new-header-nav">
              <li>
                <Link
                  className="btn btn-white med-pill"
                  to={"/login"}
                >
                  provider login
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
